import React from 'react';
import ReactDOM from 'react-dom';
import componentOrElement from 'prop-types-extra/lib/componentOrElement';
import PropTypes from 'prop-types';

export const Portal = ({ children, container }) => (container ? ReactDOM.createPortal(children, container) : <></>);

Portal.propTypes = {
  container: PropTypes.oneOfType([componentOrElement, PropTypes.func]),
  children: PropTypes.node
};

export default Portal;
